import { ArrowLeft } from "@phosphor-icons/react";
import { DownloadPanel } from "../components/DownloadPanel.js";
import { Gallery } from "../components/Gallery.js";
import { StatusBadge } from "../components/StatusBadge.js";
import { text } from "../i18n.js";
import { formatDate } from "../lib/format.js";
import { themeHref } from "../lib/routes.js";
import type { CommunityThemeView, CommunityVersionView, Locale } from "../types.js";

export function VersionPage({ locale, theme, version }: {
  readonly locale: Locale;
  readonly theme: CommunityThemeView;
  readonly version: CommunityVersionView;
}) {
  const t = text(locale);
  const content = theme.localized[locale];
  return (
    <section className="version-page">
      <div className="container">
        <a className="back-link" href={themeHref(locale, theme.id)}><ArrowLeft aria-hidden="true" />{content.name}</a>
        <div className="version-title">
          <div><StatusBadge locale={locale} status={version.supportStatus} /><h1>{content.name} <span>v{version.version}</span></h1><p>{version.changelog[locale]}</p></div>
          <dl><div><dt>{t.released}</dt><dd>{formatDate(version.releasedAt, locale)}</dd></div><div><dt>{t.schema}</dt><dd>v{version.themeSchemaVersion}</dd></div></dl>
        </div>
        {version.yankedReason ? <div className="yanked-reason" role="alert"><strong>{t.status.yanked}</strong><p>{version.yankedReason[locale]}</p></div> : null}
        <div className="detail-main-grid version-detail-grid">
          <div><Gallery locale={locale} media={[version.preview, ...version.screenshots]} themeName={`${content.name} ${version.version}`} /></div>
          <DownloadPanel locale={locale} version={version} />
        </div>
      </div>
    </section>
  );
}
